import { MessageService, type UnreadMessageCount } from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

type UnreadMessageCountApi = {
  getUnreadMessageCount: () => Promise<
    | { data: UnreadMessageCount | undefined; error: null; isSuccess: true }
    | { data: null; error: unknown; isSuccess: false }
  >;
};

const useUnreadMessageCount = (): UnreadMessageCountApi => {
  const { send: getUnreadMessageCount } = useFetchComposable(() =>
    MessageService.getUnreadMessageCount(),
  );

  return { getUnreadMessageCount };
};

export { useUnreadMessageCount };
